<template>
  <div class="rc-report-runtime" ref="rcReportDesign" :class="{'to-left':component.properties.sortType==='toLeft','hidden':component.properties.sortType==='hidden'}">
    <label class="rc-report-label">{{component.name}}</label>
    <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
      <span class="fa fa-question-circle"></span>
    </el-tooltip>
    <div class="rc-report-content">
      <report-runtime ref="reportRuntime" v-if="component.properties.report.sourceTableId" :id="component.properties.report.sourceTableId" :referenceObjParam="referenceObjParam" :key="component.properties.report.sourceTableId" @reportLoaded="reportLoaded"></report-runtime>
      <el-table v-else
                :data="tempData"
                border
                :header-row-style="{height:'28px', cursor:'pointer'}"
                :row-style="{height:'28px', cursor:'pointer',backgroundColor:'#fff'}"
                height="100%">
        <el-table-column v-for="(item, index) in columns" :key="index"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {componentMixin, calculationMixin} from './mixins'

export default {
  name: 'rc-report',
  props: ['component', 'disabled'],
  mixins: [componentMixin, calculationMixin],
  components: {
    ReportRuntime: () => import('@/components/report/runtime/report-runtime.vue')
  },
  computed: {
    columns () {
      let childrenComponent = []
      for (let i = 0; i < 4; i++) {
        childrenComponent.push({})
      }
      return childrenComponent
    }
  },
  watch: {
    async 'initState.state' (val) {
      if (val) {
        await this.getReportDataByFilters()
        if (!this.reportIsLoaded) {
          const unWatch = this.$watch('reportIsLoaded', () => {
            this.handlerComponentFilters(this.component.properties.report.filters)
            unWatch()
          })
        } else {
          this.handlerComponentFilters(this.component.properties.report.filters)
        }
      }
    }
  },
  data () {
    return {
      referenceObjParam: {
        type: 'rc-report',
        params: {
          index: 1,
          size: 4,
          filters: {}
        }
      },
      tempData: [{}, {}, {}],
      reportIsLoaded: false
    }
  },
  methods: {
    // 处理筛选项表达式
    handlerFilter (val) {
      let promises = []
      const url = `/form-api/${this.$route.name === 'formRuntimeOutsideChain' ? 'publicPublish/' : ''}runtime/calc`
      Object.keys(val).forEach(f => {
        const valueArr = this.getColumnIds(val[f])
        let variables = {}
        valueArr && valueArr.forEach(m => {
          variables[m.columnId] = this.dataService.data[m.columnId]
        })
        promises.push(new Promise(resolve => {
          this.$axios.post(url, {'formula': val[f], variables}).then(({data}) => resolve({[f]: data}))
        }))
      })
      return Promise.all(promises)
    },
    handlerComponentFilters (filters) {
      // 匹配原方法的数据结构
      // 需要每一个筛选项执行一次计算, 重新赋值给筛选项并请求报表数据
      Object.keys(filters).forEach(key => {
        if (filters[key].match(/\${(.+?)\}/g)) {
          let expression = {}
          expression.path = ['', this.component.archive.columnId]
          expression.expression = filters[key]
          // 回调重新请求报表数据
          expression.callback = (data) => {
            this.referenceObjParam.params.filters[key] = data
            this.getRcReportData()
          }
          this.getCalculationValue(expression)
        }
      })
    },
    // 重新获取报表数据
    getRcReportData () {
      this.$refs.reportRuntime.goSearch()
    },
    async getReportDataByFilters () {
      const filters = this.$_.cloneDeep(this.component.properties.report.filters)
      if (filters) {
        // 处理计算，构建筛选项，获取筛选项值
        await this.handlerFilter(filters).then(res => {
          let filterVal = {}
          res && res.forEach(f => Object.assign(filterVal, f))
          this.referenceObjParam.params.filters = filterVal
        })
      }
      this.referenceObjParam.params.size = this.component.properties.report.defaultRows
    },
    reportLoaded () {
      this.reportIsLoaded = true
    }
  }
}
</script>
<style lang="scss">
  .rc-report-runtime{
    .component-explain-tooltip {
      color: #c0c2c1;
      cursor: pointer;
      top: -0;
      position: relative;
      &:hover {
        color: #3a8ee6;
      }
    }
    .rc-report-label{
      display: inline-block;
    }
    .rc-report-content{
      height: 270px;
    }
  }
  .rc-report-runtime.to-left{
    display: flex;
    align-items: center;
    .component-explain-tooltip {
      color: #c0c2c1;
      cursor: pointer;
      top: 0px;
      left: 10px;
      z-index: 9999;
      position: relative;
      &:hover {
        color: #3a8ee6;
      }
    }
    .rc-report-label{
      display: inline-block;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .rc-report-content{
      height: 270px;
    }
  }

  .rc-report-runtime.hidden{
    .component-explain-tooltip {
      z-index: 9999;
      color: #c0c2c1;
      cursor: pointer;
      top: 135px;
      left: 0px;
      position: relative;
      &:hover {
        color: #3a8ee6;
      }
    }
    .rc-report-label{
      display: none;
    }
    .rc-report-content{
      height: 270px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-report.vue